// components
import RoomsPage from '../components/roomsPage';
import { serverSideTranslations } from '../lib/serverSideTranslations';
import { useTranslation } from '../utils/i18n';

const BookConsultingRoomsPage = () => {
  const { t } = useTranslation('common');

  return (
    <RoomsPage
      roomType="consulting"
      title={t('room_types_landing_page.consulting.title')}
      roomCategory={t('shared.clinical').toLowerCase()}
      headerTitle={t('headers.consulting_rooms.title')}
      headerDescription={t('headers.consulting_rooms.description')}
    />
  );
};

export const getServerSideProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default BookConsultingRoomsPage;
